import IndividualDevelopmentPlanListView from './component';
import _routes from './routes';

export const routes = _routes;

export default IndividualDevelopmentPlanListView;



// WEBPACK FOOTER //
// ./containers/Group/IndividualDevelopmentPlan/IndividualDevelopmentPlanListView/index.js